import { IHost } from "@Interfaces/redux/store/IHost";
import { callApi } from "repoV2/utils/common/api/callApi";

const API = {
    planPageSlug: "host/dropdown",
};

export interface IPlanSlugData {
    plan_seo_data: IHost.IPlanSeoData;
    plan_event_id: string;
    plan_uid: string;
    planData: IHost.IPlanDetail;
}

export const callGetPlanPageSlugDataApi = (
    planSlug: string,
    subDomain: string
): Promise<IPlanSlugData> =>
    callApi({
        url: `${process.env.NEXT_PUBLIC_API_URL}/${API.planPageSlug}/${subDomain}/${planSlug}`,
        extraOptions: { appendExlyBackendHeaders: true },
    })
        .then(response => {
            const data = response?.data?.data || {};
            const plan_seo_data = data?.seo_preview || {};
            const listings = data?.listings || [];
            let plan_event_id = "";
            const plan_uuid = data?.plan_uuid;
            // @dev when listing is recommended in plan listings then by default
            // recommended listing will be shown for url /plan/:planSlug
            // where planSlug can be plan_id or plan_slug and if no listing recommended
            // then first listing will be shown and plan will always have atleast one listing.
            if (listings.length) {
                const recommendedListing = listings.find(
                    (listing: any) => listing?.is_recommended === true
                );
                const [firstElementListing] = listings;
                if (recommendedListing) {
                    plan_event_id = recommendedListing.plan_listing_map_uuid;
                } else {
                    plan_event_id = firstElementListing.plan_listing_map_uuid;
                }
            }

            return {
                plan_seo_data,
                plan_event_id,
                plan_uid: plan_uuid,
                planData: data,
            };
        })
        .catch(error => {
            throw new Error(
                `Error at getInitialProps in pages/event/index when calling Plans data api. Error: ${error.toString()}`
            );
        });
